<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-modal">
      <h2>Adicionar medicamento/material</h2>
    </div>
    @if (isFirstLoading) {
      <app-loading-list></app-loading-list>
    }
    @if (!isFirstLoading) {
      <div class="body-modal">
        @if (this.listKits != null && this.listKits.length > 0 && !this.isKitsVisible) {
          <div>
            <button mat-flat-button type="button" class="add-item" color="primary"
              (click)="openAddItemInKits()">
              @if (isLoading == false) {
                <span>+ Adicionar kit</span>
              }
              @if (isLoading == true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"
                ></mat-spinner>
              }
            </button>
          </div>
        }
        @if (this.listKits != null && this.listKits.length > 0) {
          <div class="row box"
            [@expandCollapse]="isKitsVisible ? 'visible' : 'hidden'">
            <div class="title-subheader">
              <h3>Kits</h3>
            </div>
            @if (this.listKits != null && this.listKits.length > 0) {
              <div class="card-list">
                <div class="row row-list">
                  @for (item of this.listKits; track item; let index = $index) {
                    <div class="col-12 col-md-6 col-lg-4 col-xl-3">
                      <div class="card-item">
                        <div class="container-info">
                          <div class="infos">
                            <span class="primary">{{item.kitName}}</span>
                            <span class="secundary">{{item.kitCode}}</span>
                            <span class="secundary">{{item.kitTypeName}}</span>
                          </div>
                          <div class="actions action-content">
                            <mat-checkbox [(ngModel)]="item.selectForDispensingItems" (click)="verifyHasKitForDispensingItems()" matTooltip="Marcar medicamento para dispensação em massa">
                            </mat-checkbox>
                            <button (click)="openKit(item)">
                              <mat-icon aria-hidden="false" aria-label="Visualizar">
                                visibility
                              </mat-icon>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div class="button-kit row">
                  <div class="col-12 col-md-3">
                    <button mat-flat-button type="button" color="accent" class=" btn-block" (click)="cancelToDispenseKitItems()">
                      @if (isLoading == false) {
                        <span>Cancelar</span>
                      }
                      @if (isLoading == true) {
                        <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                      }
                    </button>
                  </div>
                  <div class="col-12 col-md-3">
                    <button mat-flat-button type="button" color="primary" class=" btn-block" (click)="addKitItemsForDispense()"
                      [disabled]="!this.hasKitForDispensingItems">
                      @if (isLoading == false) {
                        <span>Adicionar</span>
                      }
                      @if (isLoading == true) {
                        <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                      }
                    </button>
                  </div>
                </div>
              </div>
            }
            @if (this.listKits == null || this.listKits.length == 0) {
              <app-empty-list
                [message]="'Não há kits cadastrados'">
              </app-empty-list>
            }
          </div>
        }
        @if (!isFirstLoading) {
          <form class="form" [formGroup]="model" (ngSubmit)="submit()">
            <div class="row">
              <div class="title-subheader">
                <h3>Materiais</h3>
              </div>
              @if (model.get('listItems')['controls'].length == 0) {
                <div>
                  <button mat-flat-button type="button" class="add-item" color="primary"
                    (click)="addNextInputItem()" [disabled]="buttonToSaveDisabled">
                    @if (isLoading == false) {
                      <span>+ Adicionar material</span>
                    }
                    @if (isLoading == true) {
                      <mat-spinner [diameter]="30" class="mat-spinner-btn"
                      ></mat-spinner>
                    }
                  </button>
                </div>
              }
              @if (model.get('listItems')['controls'].length > 0) {
                <div >
                  @for (formModel of model.get('listItems')['controls']; track formModel; let i = $index) {
                    <div class="row" formArrayName="listItems"
                      >
                      <div class="col-12" [formGroupName]="i">
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-5">
                            <mat-form-field appearance="outline">
                              <mat-label>Material</mat-label>
                              <mat-select formControlName="idItem" (selectionChange)="selectItem($event.value, i)">
                                <input class="inputSearchSelect" type="text" (keyup)="onKeySearchItem($event.target.value)"
                                  (keydown)="$event.stopImmediatePropagation()" placeholder="Pesquisar"
                                  autocomplete="off">
                                  @for (item of listItem; track item) {
                                    <mat-option [value]="item.additionalItemForPrescriptionRelease.idItem"
                                      [disabled]="verifyItemAlredySelected(item.additionalItemForPrescriptionRelease.idItem, formModel.get('idItem').value)">
                                      {{item.additionalItemForPrescriptionRelease.itemName}}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="col-6 col-sm-6 col-md-3 col-lg-2">
                              <mat-form-field appearance="outline">
                                <mat-label>Quantidade</mat-label>
                                <input matInput type="text" formControlName="quantity" min="1"
                                  oninput="this.value = this.value.replace(/[^0-9]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');"
                                  (keyup)="onKeyChangeQuantity($event, i, 'listItems')"/>
                                  @if (formModel.get('quantity')?.invalid) {
                                    <mat-error>Preenchimento incorreto</mat-error>
                                  }
                                </mat-form-field>
                              </div>
                              <div class="col-12 col-sm-12 col-md-3">
                                <mat-form-field appearance="outline">
                                  <mat-label>Local e estoque</mat-label>
                                  <mat-select formControlName="idStorage">
                                    @for (item of formModel.get('item').value?.listStorageAmountLocationStruct; track item) {
                                      <mat-option [value]="item.idStorage"
                                        [disabled]="item.amountRemaining < $safeNavigationMigration(formModel.get('quantity')?.value)">
                                        {{item.location}} - {{item.storageBatch}} - Total: {{item.amountRemaining}}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                              </div>
                              <div class="col-6 col-sm-6 col-md-3 col-lg-2">
                                <button class="side-button " color="primary" mat-mini-fab type="button"
                                  (click)="addNextInputItem()">
                                  <mat-icon aria-hidden="false" aria-label="Menu apps">add</mat-icon>
                                </button>
                                <button class="side-button " color="primary" mat-mini-fab type="button"
                                  (click)="removeInputItem(i)">
                                  <mat-icon aria-hidden="false" aria-label="Menu apps">remove</mat-icon>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
                <hr/>
                <div class="row">
                  <div class="title-subheader">
                    <h3>Medicamentos</h3>
                  </div>
                  @if (model.get('listMedicines')['controls'].length == 0) {
                    <div>
                      <button mat-flat-button type="button" class="add-item" color="primary"
                        (click)="addNextInputMedicine()" [disabled]="buttonToSaveDisabled">
                        @if (isLoading == false) {
                          <span>+ Adicionar item</span>
                        }
                        @if (isLoading == true) {
                          <mat-spinner [diameter]="30" class="mat-spinner-btn"
                          ></mat-spinner>
                        }
                      </button>
                    </div>
                  }
                  @if (model.get('listMedicines')['controls'].length > 0) {
                    <div >
                      @for (formModel of model.get('listMedicines')['controls']; track formModel; let i = $index) {
                        <div class="row" formArrayName="listMedicines"
                          >
                          <div class="col-12" [formGroupName]="i">
                            <div class="row">
                              <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-5">
                                <mat-form-field appearance="outline">
                                  <mat-label>Material</mat-label>
                                  <mat-select formControlName="idItem" (selectionChange)="selectMedicine($event.value, i)">
                                    <input class="inputSearchSelect" type="text" (keyup)="onKeySearchMedicine($event.target.value)"
                                      (keydown)="$event.stopImmediatePropagation()" placeholder="Pesquisar"
                                      autocomplete="off">
                                      @for (item of listMedicine; track item) {
                                        <mat-option [value]="item.additionalMedicineForPrescriptionRelease.idMedicine"
                                          [disabled]="verifyMedicineAlredySelected(item.additionalMedicineForPrescriptionRelease.idMedicine, formModel.get('idItem').value)">
                                          {{item.additionalMedicineForPrescriptionRelease.medicineDescription}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                                <div class="col-6 col-sm-6 col-md-3 col-lg-2">
                                  <mat-form-field appearance="outline">
                                    <mat-label>Quantidade</mat-label>
                                    <input matInput type="text" formControlName="quantity" min="0.001"
                                      (keyup)="onKeyChangeQuantity($event, i, 'listMedicines')" appDecimalQuantityValidator/>
                                      @if (formModel.get('quantity')?.invalid) {
                                        <mat-error>Preenchimento incorreto</mat-error>
                                      }
                                    </mat-form-field>
                                  </div>
                                  <div class="col-12 col-sm-12 col-md-3">
                                    <mat-form-field appearance="outline">
                                      <mat-label>Local e estoque</mat-label>
                                      <mat-select formControlName="idStorage">
                                        @for (item of formModel.get('item').value?.listStorageAmountLocationStruct; track item) {
                                          <mat-option [value]="item.idStorage"
                                            [disabled]="item.amountRemaining < $safeNavigationMigration(formModel.get('quantity')?.value)">
                                            {{item.location}} - {{item.storageBatch}} - Total: {{item.amountRemaining}}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                  <div class="col-6 col-sm-6 col-md-3 col-lg-2">
                                    <button class="side-button " color="primary" mat-mini-fab type="button"
                                      (click)="addNextInputMedicine()">
                                      <mat-icon aria-hidden="false" aria-label="Menu apps">add</mat-icon>
                                    </button>
                                    <button class="side-button " color="primary" mat-mini-fab type="button"
                                      (click)="removeInputMedicine(i)">
                                      <mat-icon aria-hidden="false" aria-label="Menu apps">remove</mat-icon>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </form>
                }
              </div>
            }
          </div>
        </div>
        <div mat-dialog-footer class="footer-modal">
          <div class="row">
            <div class="col-12 col-md-6">
              <button mat-flat-button type="button" color="accent" class=" btn-block" (click)="close()">
                @if (isLoading == false) {
                  <span>Cancelar</span>
                }
                @if (isLoading == true) {
                  <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
              </button>
            </div>
            <div class="col-12 col-md-6">
              <button mat-flat-button type="button" color="primary" class=" btn-block" (click)="submit()">
                @if (isLoading == false) {
                  <span>Salvar</span>
                }
                @if (isLoading == true) {
                  <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
              </button>
            </div>
          </div>
        </div>